import { Box, Button, CircularProgress, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";

const primaryButtonSx = { bgcolor: "#0054A5", borderRadius: 2, px: 3, "&:hover": { bgcolor: "#003d7a" } };

const UnsavedChangesBar = ({ saving, onSave }) => (
  <>
    <Typography variant="subtitle2" fontWeight={700} color="#e65100">
      יש שינויים לא שמורים — שמור לפני שחרור
    </Typography>
    <Button
      variant="contained"
      onClick={onSave}
      disabled={saving}
      startIcon={saving ? <CircularProgress size={16} color="inherit" /> : <SaveIcon />}
      sx={primaryButtonSx}
    >
      {saving ? "שומר..." : "שמור עדכונים ב-Priority"}
    </Button>
  </>
);

const ReleaseStatusSelect = ({ release }) => (
  <Box display="flex" flexDirection="column" gap={0.5}>
    <FormControl size="small" sx={{ minWidth: 220 }}>
      <InputLabel>בחר סטטוס לשחרור</InputLabel>
      <Select
        value={release.selectedStatus}
        onChange={(e) => release.setSelectedStatus(e.target.value)}
        label="בחר סטטוס לשחרור"
        sx={{ bgcolor: "#ffffff", borderRadius: 2 }}
      >
        {release.availableStatuses.map((s) => (
          <MenuItem key={s} value={s}>
            {s}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    {release.selectedStatus === release.suggestedStatus && (
      <Typography variant="caption" color="#6b7280" sx={{ fontSize: "0.68rem" }}>
        ✦ מוצע אוטומטית
      </Typography>
    )}
  </Box>
);

const ReleaseControls = ({ release, onRejectClick }) => (
  <>
    <Typography variant="subtitle2" fontWeight={700} color="#1f2937">
      שחרור הזמנה:
    </Typography>
    <ReleaseStatusSelect release={release} />
    <Button
      variant="contained"
      onClick={release.release}
      disabled={!release.selectedStatus || release.updating}
      startIcon={release.updating ? <CircularProgress size={16} color="inherit" /> : <CheckCircleOutlineIcon />}
      sx={primaryButtonSx}
    >
      {release.updating ? "מעדכן..." : "עדכן סטטוס"}
    </Button>
    {onRejectClick && (
      <Button
        variant="outlined"
        color="error"
        onClick={onRejectClick}
        disabled={release.updating}
        startIcon={<CancelIcon />}
        sx={{ borderRadius: 2, px: 3 }}
      >
        דחייה
      </Button>
    )}
  </>
);

// Bottom of an expanded order: save pending line edits first, otherwise release / reject.
const OrderActionsBar = ({ itemEdits, release, onRejectClick }) => (
  <>
    <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
      {itemEdits.hasDirty ? (
        <UnsavedChangesBar saving={itemEdits.saving} onSave={itemEdits.save} />
      ) : (
        <ReleaseControls release={release} onRejectClick={onRejectClick} />
      )}
    </Box>
    {release.updateError && (
      <Typography variant="caption" color="error" sx={{ display: "block", mt: 1 }}>
        {release.updateError}
      </Typography>
    )}
  </>
);

export default OrderActionsBar;
